<template>
  <b-field class="has-background-white" style="flex-direction: column;">
    <p class="control">
      <b-tooltip position="is-left" label="Increase zoom level">
        <b-button @click="increaseZoom">
          <b-icon icon="plus"></b-icon>
        </b-button>
      </b-tooltip>
    </p>
    <p class="control">
      <b-tooltip position="is-left" label="Decrease zoom level">
        <b-button @click="decreaseZoom">
          <b-icon icon="minus"></b-icon>
        </b-button>
      </b-tooltip>
    </p>
    <p class="control">
      <b-tooltip position="is-left" label="Fit to width">
        <b-button @click="fitToWidth">
          <b-icon  icon="compress"></b-icon>
        </b-button>
      </b-tooltip>
    </p>
    <p class="control">
      <b-tooltip position="is-left" label="Fullscreen">
        <b-button @click="fullscreen">
          <b-icon  icon="expand"></b-icon>
        </b-button>
      </b-tooltip>
    </p>
  </b-field>
</template>
<style >
.field.has-addons {
	display: flex;
  justify-content: flex-start;
	flex-direction: column;
}

</style>

<script>

export default {
  methods: {
    increaseZoom() {
      this.$emit("input", { type: "zoom", delta: 1 });
    },
    decreaseZoom() {
      this.$emit("input", { type: "zoom", delta: -1 });
    },
    home() {
      this.$emit("input", { type: "home" });
    },
    fitToWidth() {
      this.$emit("input", { type: "fit" });
    },
    fullscreen() {
      this.$fullscreen.toggle();
    },
  },
};
</script>
